import serviceRequestApi from '@/api/servicerequest'
import { SERVICE_REQUEST } from '../types'
import Vue from 'vue'
import serviceRequest from '../../api/servicerequest'
import utils from '../../utils/utils'

export default {
  namespaced: true,
  state: {
    currentDate: null,
    locationQueryFilter: null,
    clientFilter: null,
    requests: [],
    selectedRequest: {}
  },
  getters:{
    locationQueryFilter: (state) => {
      return state.locationQueryFilter
    },
    clientFilter: (state) => {
      return state.clientFilter
    },
    currentDate: (state) => {
      return state.currentDate
    }
  },
  mutations: {
    [SERVICE_REQUEST.CURRENT_DATE_SET] (state, currentDate) {
      state.currentDate = currentDate
    },
    [SERVICE_REQUEST.SET_LOCATION_QUERY_FILTER] (state, locationQueryFilter) {
      state.locationQueryFilter = locationQueryFilter
    },
    [SERVICE_REQUEST.SET_CLIENT_FILTER] (state, clientFilter) {
      state.clientFilter = clientFilter
    },
    [SERVICE_REQUEST.SET_REQUESTS] (state, requests) {
      state.requests = requests
    },
    [SERVICE_REQUEST.SET_SELECTED_REQUEST] (state, request) {
      state.selectedRequest = request
    }
  },
  actions: {
    setCurrentDate: function ({commit}, currentDate) {
      commit(SERVICE_REQUEST.CURRENT_DATE_SET, currentDate)
    },
    setLocationQueryFilter: function ({commit}, locationQueryFilter) {
      commit(SERVICE_REQUEST.SET_LOCATION_QUERY_FILTER, locationQueryFilter)
    },
    setClientFilter: function ({commit}, clientFilter) {
      commit(SERVICE_REQUEST.SET_CLIENT_FILTER, clientFilter)
    },
    setLocation: function ({commit}, location) {
      commit(SERVICE_REQUEST.SET_LOCATION, location)
    },
    setSelectedRequest: function ({commit}, item) {
      commit(SERVICE_REQUEST.SET_SELECTED_REQUEST, item)
    },
    getServicesRequest: function ({ commit, dispatch, state }) {
      return new Promise((resolve, reject) => {
        dispatch('Global/showLoading', null, {root: true})
        commit(SERVICE_REQUEST.SET_REQUESTS, [])
        serviceRequestApi.getServicesRequest(Vue.prototype.$moment(state.currentDate).toISOString()).then((response) => {
          dispatch('Global/hideLoading', null, {root: true})
          commit(SERVICE_REQUEST.SET_REQUESTS, response.data)
          resolve(response)
        }).catch((error) => {
          dispatch('Global/hideLoading', null, {root: true})
          commit(SERVICE_REQUEST.SET_REQUESTS, [])
          reject(error)
        })
      })
    },
    approveRequest: function ({state, dispatch}) {
      const { eventId, roomIds, serviceId, client} = state.selectedRequest
      const request = {
        clientId: client.id,
        eventId,
        serviceId 
      }
      return new Promise((resolve, reject) => {
        dispatch('Global/showLoading', null, {root: true})
        serviceRequestApi.approveRequest(request, roomIds).then((response) => {
          dispatch('getServicesRequest')
          resolve(response)
        }).catch((error) => {
          dispatch('Global/hideLoading', null, {root: true})
          reject(error)
        })
      })
    },
    rejectRequest: function ({state, dispatch}) {
      const { eventId, roomIds, serviceId, client} = state.selectedRequest
      const request = {
        clientId: client.id,
        eventId,
        serviceId 
      }
      return new Promise((resolve, reject) => {
        dispatch('Global/showLoading', null, {root: true})
        serviceRequestApi.rejectRequest(request, roomIds).then((response) => {
          dispatch('getServicesRequest')
          resolve(response)
        }).catch((error) => {
          dispatch('Global/hideLoading', null, {root: true})
          reject(error)
        })
      })
    },
    batchApproveRequests: async function ({ dispatch }, selectedItems) {
      dispatch('Global/showLoading', null, {root: true})
      
      // Group items by eventId and clientId to batch API calls
      const groupedByEvent = selectedItems.reduce((acc, item) => {
        const key = `${item.client.id}|${item.eventId}`
        if (!acc[key]) {
          acc[key] = {
            clientId: item.client.id,
            eventId: item.eventId,
            roomIds: item.roomIds,
            serviceIds: [],
            items: []
          }
        }
        acc[key].serviceIds.push(item.serviceId)
        acc[key].items.push(item)
        return acc
      }, {})
      
      // Make one API call per event with all serviceIds for that event
      const promises = Object.values(groupedByEvent).map(group => {
        const request = {
          clientId: group.clientId,
          eventId: group.eventId,
          serviceIds: group.serviceIds
        }
        return serviceRequest.approveRequest(request, group.roomIds)
          .then(response => ({ status: 'fulfilled', items: group.items, response }))
          .catch(error => ({ status: 'rejected', items: group.items, error }))
      })
      
      const groupResults = await Promise.all(promises)
      
      // Flatten results back to individual items for handleBatchResults compatibility
      const results = groupResults.flatMap(groupResult => 
        groupResult.items.map(item => ({
          status: groupResult.status,
          item: item,
          response: groupResult.response,
          error: groupResult.error
        }))
      )
      
      await dispatch('getServicesRequest')
      dispatch('Global/hideLoading', null, {root: true})
      
      return results
    },
    batchRejectRequests: async function ({ dispatch }, selectedItems) {
      dispatch('Global/showLoading', null, {root: true})
      
      // Group items by eventId and clientId to batch API calls
      const groupedByEvent = selectedItems.reduce((acc, item) => {
        const key = `${item.client.id}|${item.eventId}`
        if (!acc[key]) {
          acc[key] = {
            clientId: item.client.id,
            eventId: item.eventId,
            roomIds: item.roomIds,
            serviceIds: [],
            items: []
          }
        }
        acc[key].serviceIds.push(item.serviceId)
        acc[key].items.push(item)
        return acc
      }, {})
      
      // Make one API call per event with all serviceIds for that event
      const promises = Object.values(groupedByEvent).map(group => {
        const request = {
          clientId: group.clientId,
          eventId: group.eventId,
          serviceIds: group.serviceIds
        }
        return serviceRequest.rejectRequest(request, group.roomIds)
          .then(response => ({ status: 'fulfilled', items: group.items, response }))
          .catch(error => ({ status: 'rejected', items: group.items, error }))
      })
      
      const groupResults = await Promise.all(promises)
      
      // Flatten results back to individual items for handleBatchResults compatibility
      const results = groupResults.flatMap(groupResult => 
        groupResult.items.map(item => ({
          status: groupResult.status,
          item: item,
          response: groupResult.response,
          error: groupResult.error
        }))
      )
      
      await dispatch('getServicesRequest')
      dispatch('Global/hideLoading', null, {root: true})
      
      return results
    },
    clearFilters: function ({commit}){
      commit(SERVICE_REQUEST.SET_LOCATION_QUERY_FILTER, null)
      commit(SERVICE_REQUEST.SET_CLIENT_FILTER, null)
      commit(SERVICE_REQUEST.CURRENT_DATE_SET, null)
      commit(SERVICE_REQUEST.SET_REQUESTS, null)
    },
    async getServiceDeskReport ({dispatch}, params) {
      dispatch('Global/showLoading', null, {root: true})
      try {
        let reportName = `${params.startDate} - ${params.endDate}.xlsx`
        let response = await serviceRequest.getReport(params.startDate, params.endDate)
        let contentType = response.headers['content-type']
        let blob = new Blob([response.data], { type: contentType })
        utils.handleDownload(blob, reportName)
      } finally {
        dispatch('Global/hideLoading', null, {root: true})
      }
    },
  }
}
